/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React from "react";
import documentProperties from "dc-icons/chrome_extension/SDC_DocumentProperties_18_N.svg";
import CustomIcon from "dc-preview-utils/src/components/CustomIcon";
import { documentPropertiesMenuItems, docPropertiesDialogTriggerPoint } from "constants/enums";
import { openDocPermissionDialog } from "utils/DocPermissionsUtils";

export const getDocPropertiesAction = props => ({
  id: "documentProperties",
  label: props.intl.formatMessage({ id: "modernviewer.label.docProperties" }),
  ariaLabel: props.intl.formatMessage({ id: "modernviewer.arialabel.docProperties" }),
  onClick: () => {
    openDocPermissionDialog(documentPropertiesMenuItems.DESCRIPTION, docPropertiesDialogTriggerPoint.TOPBAR);
  },
  Icon: <CustomIcon url={documentProperties} />
});
